import BaseLayer from "./BaseLayer";
import {plotTileMotionHelper} from "../utils/map_utils";

class StitchRound2TileMotionv2 extends BaseLayer {

    id = "stitchRound2TileMotionv2";
    label = "Tiles Moved";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchR2TileMotion, textColor} = this.props;
        plotTileMotionHelper(stitchR2TileMotion, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchRound2TileMotionv2;
